/* global contextPath */

// RegistrationController
export const REGISTER = {
  PATH_REGISTER_USER: contextPath + '/register',
  PATH_CONFIRM_USERNAME: contextPath + '/register/',
  PATH_CONFIRM_PROFILE: contextPath + '/register/',
  PATH_SEND_CONFIRM_USERNAME: contextPath + '/register/code'
}

// LoginController
export const LOGIN = {
  PATH_CHECK_USER: contextPath + '/login/user',
  PATH_PASSWORD: contextPath + '/login/pass', // POST = login, PUT = send pw reset code, PATCH = confirm pw reset
  PATH_OTP: contextPath + '/login/otp', // POST = login, PUT = resend OTP
  PATH_CONSENT_SCOPES: contextPath + '/consent', // POST = login, PUT = resend OTP
  PATH_SET_COUNTRY: contextPath + '/country/',
  PATH_GET_AUTH_STATE: contextPath + '/login/mme/status',
  PATH_MME_LOGIN: contextPath + '/login/mme',
  PATH_SET_EMAIL: contextPath + '/email',
  PATH_SET_MOBILE: contextPath + '/mobile'
}

// ToasController
export const TOAS = {
  PATH_REGISTRATION_TEXTS: contextPath + '/toas/registrationTexts',
  PATH_SAVE_LOGIN_CONSENT: contextPath + '/toas/saveLoginConsent',
  PATH_FETCH_LEGALTEXT: contextPath + '/toas/legalText',
  PATH_FETCH_LEGALNOTICES: contextPath + '/toas/legalNotices'
}

// TranslationController
export const TRANSLATION = {
  PATH_TRANSLATIONS_JSON: contextPath + '/translation/json',
  PATH_SCOPES_TRANSLATIONS: contextPath + '/translation/'
}

export const LOGOUT = {
  PATH_REVOKE_SESSION: contextPath + '/sessions/revoke/'
}
